import { useEffect, RefObject } from 'react';

type PlayerReInitProps = {
  isModalOpen: boolean;
  playerContainerRef: RefObject<HTMLDivElement | null>;
};

export const usePlayerReInit = ({
  isModalOpen,
  playerContainerRef
}: PlayerReInitProps) => {
  useEffect(() => {
    if (!playerContainerRef.current || !isModalOpen) return;

    window?.wavePlayer?.init?.(playerContainerRef.current);
  }, [isModalOpen, playerContainerRef.current]);
};
